import React, { useEffect, useState } from 'react';
import styles from './FAQSection.module.css';
import { trackCtaClick } from '../../../../utils/analytics';
import OwnNumberNote from '../shared/OwnNumberNote';

function FAQSection({ onScrollToBeta }) {
  // Estado para controlar qual item do FAQ está expandido (accordion exclusivo)
  const [expandedFaq, setExpandedFaq] = useState(null);

  // Estado para armazenar os dados do FAQ
  const [faqData, setFaqData] = useState({
    loading: true,
    error: null,
    items: []
  });

  // Função para alternar a expansão/recolhimento de um item do FAQ
  // Apenas um item pode estar aberto por vez (accordion exclusivo)
  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  // Efeito para carregar os dados do FAQ do arquivo JSON
  useEffect(() => {
    fetch('/data/faq.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Não foi possível carregar os dados do FAQ');
        }
        return response.json();
      })
      .then(data => {
        setFaqData({
          loading: false,
          error: null,
          items: data.faq || []
        });
      })
      .catch(error => {
        setFaqData({
          loading: false,
          error: error.message,
          items: []
        });
      });
  }, []);

  // Divide os itens em duas colunas: ímpares (col 1) e pares (col 2)
  const col1 = faqData.items.filter((_, i) => i % 2 === 0);
  const col2 = faqData.items.filter((_, i) => i % 2 !== 0);

  const renderItem = (item, originalIndex) => (
    <div
      key={item.id || originalIndex}
      className={`${styles.faqItem} ${expandedFaq === originalIndex ? styles.faqItemExpanded : ''}`}
      onClick={() => toggleFaq(originalIndex)}
    >
      <div className={styles.faqQuestion}>
        <h3>{item.question}</h3>
        <span className={styles.faqToggleIcon} aria-hidden="true">
          {expandedFaq === originalIndex ? '−' : '+'}
        </span>
      </div>
      <div className={styles.faqAnswer}>
        <p>{item.answer}</p>
      </div>
    </div>
  );

  return (
    <section id="duvidas" className={styles.faqSection}>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Dúvidas frequentes</h2>
          <p className={styles.sectionSubtitle}>
            Respostas rápidas para você começar com segurança.
          </p>
        </div>

        {faqData.loading ? (
          <div className={styles.faqLoading}>Carregando perguntas e respostas...</div>
        ) : faqData.error ? (
          <div className={styles.faqError}>{faqData.error}</div>
        ) : (
          <>
            <div className={styles.faqGrid}>
              <div className={styles.faqColumn}>
                {col1.map((item) => {
                  const originalIndex = faqData.items.indexOf(item);
                  return renderItem(item, originalIndex);
                })}
              </div>
              <div className={styles.faqColumn}>
                {col2.map((item) => {
                  const originalIndex = faqData.items.indexOf(item);
                  return renderItem(item, originalIndex);
                })}
              </div>
            </div>
            <OwnNumberNote className={styles.sectionNote} />
          </>
        )}

        <div className={styles.sectionCta}>
          <button
            className={styles.ctaButton}
            onClick={() => {
              trackCtaClick({ placement: 'faq_section_cta' });
              onScrollToBeta();
            }}
          >
            Começar meu teste grátis
          </button>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
